module.exports = __webpack_public_path__ + "img/img2.a3cf0565.png";